import {api} from "./Api";

export const emailService = {
    sendEmail: (data) => api.post("/usermgmt/sendMailForWebsite", data),
};